module.exports = __webpack_public_path__ + "img/t1.833a8074.svg";